import { render, staticRenderFns } from "./FormAutenticacao.vue?vue&type=template&id=6b880fc3&scoped=true&"
import script from "./FormAutenticacao.vue?vue&type=script&lang=js&"
export * from "./FormAutenticacao.vue?vue&type=script&lang=js&"
import style0 from "./FormAutenticacao.vue?vue&type=style&index=0&id=6b880fc3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b880fc3",
  null
  
)

export default component.exports